import styles from '/builds/sitegeist/bad-toelz-de/.build/releases/1/DistributionPackages/BadToelz.BadToelzDe/Resources/Private/Fusion/Presentation/ContentElements/TextOnBackgroundImage/TextOnBackgroundImage.css';

export const prototypeName = 'wXVlw0r8boC6raNlp1LVUPLjjN5DVKFqLvAvqNyKI4ygL7G7q6i02a2lNLq2iy4kAMPrqQhRlaD7N123CXKdAQZppWul3r3o';
export {styles};